import { render, staticRenderFns } from "./InvoicePreviewVersion.vue?vue&type=template&id=21a6e950&scoped=true&"
import script from "./InvoicePreviewVersion.vue?vue&type=script&lang=js&"
export * from "./InvoicePreviewVersion.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePreviewVersion.vue?vue&type=style&index=0&id=21a6e950&lang=scss&scoped=true&"
import style1 from "./InvoicePreviewVersion.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a6e950",
  null
  
)

export default component.exports